import React from 'react';
import { WarningOutlined } from '@ant-design/icons';

const FieldWarning = ({ message }) => {
    if (!message) return null;

    return (
        <div className="smart-defaults-field-warning smart-defaults-field-warning--inline" role="note">
            <WarningOutlined className="smart-defaults-field-warning__icon" aria-hidden />
            <span>{message}</span>
        </div>
    );
};

export default FieldWarning;
